<script setup lang="ts">
import moneyFormat from "../utils/moneyFormat";
import {computed, toRefs} from "vue";
import {dateToFormattedString, formatDateToUS} from "@/utils/dateUtils";
import type { LineItem } from "@/stores/cartStore";

const properties = defineProps<{
  lineItem: LineItem;
  index: number;
}>();
const { lineItem, index } = toRefs(properties);

const selectedDateText = computed(() => {
  if(lineItem.value.selectedRate && lineItem.value.selectedRate.estimatedDate) {
    if(Array.isArray(lineItem.value.selectedRate.estimatedDate)) {
      return `<span class="white-space-nowrap">${dateToFormattedString(lineItem.value.selectedRate.estimatedDate[0])}</span> - <span class="white-space-nowrap">${dateToFormattedString(lineItem.value.selectedRate.estimatedDate[1])}</span>`;
    } else {
      return dateToFormattedString(lineItem.value.selectedRate.estimatedDate)
    }
  }

  return "Need More Information";
});

</script>
<template>
  <div class="list-productsl__item">
    <div class="list-productsl__shipment">
      <template v-if="!lineItem.properties._gift_type || lineItem.properties._gift_type === '1'">
        <span class="gift-to">Myself -</span>
      </template>
      <template v-else-if="lineItem.properties && lineItem.properties._gift_type === '2' && (lineItem.properties._gift_first_name || lineItem.properties._gift_last_name)">
        <span class="gift-to">{{ lineItem.properties._gift_first_name }} {{ lineItem.properties._gift_last_name }} -</span>
      </template>
      <template v-else-if="lineItem.selectedAddress">
        <span class="gift-to">{{ lineItem.selectedAddress.first_name }} {{ lineItem.selectedAddress.last_name }} -</span>
      </template>
      Shipment {{ index+1 }}
    </div>
    <a href="/products/c-kruegers-every-occasion-half-dozen-sampler?variant=39817690906691" class="list-productsl__head">
      <span class="list-productsl__head-ttl">{{ lineItem.product_title }}</span>
      <span class="list-productsl__head-price">
        {{ moneyFormat(lineItem.final_line_price, true) }}
        <template v-if="lineItem.quantity > 1">
          <span class="list-productsl__head-price-each">({{ moneyFormat(lineItem.price, true) }} each)</span>
        </template>
      </span>
    </a>
    <template v-if="lineItem.variant_options.length && lineItem.variant_options[0] !== 'Default Title'">
      <p class="list-productsl__variant">{{ lineItem.variant_options.join(' / ') }}</p>
    </template>
    <p class="list-productsl__head-qty">Quantity: <strong>{{ lineItem.quantity }}</strong></p>
    <div class="list-productsl__info">
      <div class="list-productsl__info-itm">
        Shipping method: <span data-type="summary-method">{{ lineItem.selectedRate && lineItem.selectedRate.presentment_name || 'Need More Information' }}</span>
      </div>
      <div class="list-productsl__info-itm">
        Shipping price: <span data-type="summary-price">{{ lineItem.selectedRate && lineItem.selectedRate.price ? parseInt(lineItem.selectedRate.price) ? moneyFormat(lineItem.selectedRate.price * 100, true) : 'Free' : 'Need More Information' }}</span>
      </div>
      <div class="list-productsl__info-itm">
        Estimated delivery date: <span v-html="selectedDateText"></span>
      </div>
      <template v-if="lineItem.line_level_total_discount">
        <div class="list-productsl__info-itm list-productsl__info-itm_discount">
          Discount: <span>{{ moneyFormat(lineItem.line_level_total_discount, true) }}</span>
        </div>
      </template>
    </div>
    <div class="list-productsl__info--sum">
      Subtotal <span data-type="summary-total">{{ moneyFormat(lineItem.final_line_price / 100 + (parseFloat(lineItem.selectedRate?.price) || 0)) }}</span>
    </div>
  </div>
</template>